<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">添加供应商</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.state == 0" @click="onUpdateEvent(rowItem.record.id)">启用</a>
        <a v-else @click="onUpdateEvent(rowItem.record.id)">禁用</a>
      </span>
    </custom-page-table>
    <a-modal title="添加供应商" :width="666" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="优点巴士账号" prop="accountId">
          <a-input v-model.trim="ruleForm.accountId" :maxLength="50" placeholder="优点巴士账号"></a-input>
        </a-form-model-item>
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" :maxLength="6"
                   placeholder="仅用于区分标识数据来源，6个字内"></a-input>
        </a-form-model-item>
        <a-form-model-item label="接口域名(url)" prop="reqUrl">
          <a-input v-model.trim="ruleForm.reqUrl" placeholder="接口域名(url)" :maxLength="125"></a-input>
        </a-form-model-item>
        <a-form-model-item label="渠道ID(channelid)" prop="channelId">
          <a-input v-model.trim="ruleForm.channelId" placeholder="渠道ID(channelid)" :maxLength="10"/>
        </a-form-model-item>
        <a-form-model-item label="业务类型(biztype)" prop="bizType">
          <a-input v-model.trim="ruleForm.bizType" placeholder="业务类型(biztype)" :maxLength="10"/>
        </a-form-model-item>
        <a-form-model-item label="密钥(signkey)" prop="signKey">
          <a-input v-model.trim="ruleForm.signKey" placeholder="密钥(signkey)" :maxLength="255"></a-input>
        </a-form-model-item>
        <a-form-model-item label="私钥(key)" prop="privateKey">
          <a-input v-model.trim="ruleForm.privateKey" placeholder="私钥(key)" :maxLength="255"></a-input>
        </a-form-model-item>
        <a-form-model-item label="初始化向量参数(iv)" prop="iv">
          <a-input v-model.trim="ruleForm.iv" placeholder="初始化向量参数(iv)" :maxLength="255"></a-input>
        </a-form-model-item>
        <div style="text-align: center;">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">提交</a-button>
        </div>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'BusNewAccount',
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '优点巴士账号',
          dataIndex: 'accountId'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '接口域名',
          dataIndex: 'reqUrl'
        },
        {
          title: '渠道ID',
          dataIndex: 'channelId'
        },
        {
          title: '业务类型',
          dataIndex: 'bizType'
        },
        {
          title: '状态',
          dataIndex: 'stateStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '110px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      visible: false,
      submitLoading: false,
      ruleForm: {
        accountId: '',// 优点巴士账号id ,
        bizType: '',// 业务类型 ,
        channelId: '',// 渠道id ,
        id: '',// 账号id 编辑时使用 ,
        iv: '',// 初始化向量参数 ,
        privateKey: '',// 私钥 ,
        reqUrl: '',// 接口域名 ,
        signKey: '',// 密钥 ,
        supplierName: '',// 供应商名称
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      rules: {
        accountId: [{ required: true, message: '请输入优点巴士账号', trigger: 'blur' }],
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        reqUrl: [{ required: true, message: '请输入接口域名', trigger: 'blur' }],
        channelId: [
          { required: true, message: '请输入渠道ID(channelid)', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        bizType: [
          { required: true, message: '请输入业务类型(biztype)', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        signKey: [{ required: true, message: '请输入密钥(signkey)', trigger: 'blur' }],
        privateKey: [{ required: true, message: '请输入私钥(key)', trigger: 'blur' }],
        iv: [{ required: true, message: '请输入初始化向量参数', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BusConnection', title: '商品绑定' },
      { name: 'BusOrderConnection', title: '订单直连' },
      { name: 'BusNewAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('ydbus/findYdBusAccountList', params)
    },
    //启用事件
    enableEvent(providerId) {
      this.updateProviderStatus(providerId, 1)
    },
    //编辑事件
    editEvent(item) {
      this.getLogUtils().logWithTag('editEvent== item', item)
      this.ruleForm = item
      this.visible = true
    },
    //启禁用事件
    onUpdateEvent(id) {
      this.updateProviderStatus(id)
    },
    //状态更新
    updateProviderStatus(id) {
      this.getHttpServices().getServerApiService().post('ydbus/editYdBusAccountState?id=' + id).then(res => {
        this.$refs.table.refresh(true)
        this.$message.success('状态更新成功')
      }).catch(err => {
        this.getLogUtils().logWithTag(err)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('ydbus/editYdBusAccount', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('数据更新成功')
        this.visible = false
        this.resetFrom()
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    openModel() {
      this.visible = true
    },
    resetFrom() {
      this.ruleForm = {
        accountId: '',// 优点巴士账号id ,
        bizType: '',// 业务类型 ,
        channelId: '',// 渠道id ,
        id: '',// 账号id 编辑时使用 ,
        iv: '',// 初始化向量参数 ,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        privateKey: '',// 私钥 ,
        reqUrl: '',// 接口域名 ,
        signKey: '',// 密钥 ,
        supplierName: ''// 供应商名称
      }
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped></style>
